import { HomeGroupPlusIcon } from './HomeGroupPlusIcon';

/**
 * author: LEANNOVATORS.TECH
 * id 6A0C18F6-510F-4AC3-88FE-6B24C7669BAD
 * name home-group-plus
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-group-plus.svg
 * tags
 * - Home Automation 
 */
export const HouseGroupPlusIcon = HomeGroupPlusIcon;
export default HouseGroupPlusIcon